import { ROUTES, SETTINGS_ROUTES } from "@/shared/constants/routes";
import ClipboardPenIcon from "@/shared/images/clipboard-pen.svg";
import { useLoggedInMember } from "@modules/auth/states";
import { getZaniaTeamMemberRoles } from "@modules/team/states";
import { Card, CardBody } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";

const ThirdPartyRiskLanding = () => {
  const navigate = useNavigate();
  const member = useLoggedInMember();
  const { isTeamOrgAdmin, isTeamAdmin } = member
    ? getZaniaTeamMemberRoles("", member)
    : { isTeamOrgAdmin: false, isTeamAdmin: false };

  const isAdmin = isTeamOrgAdmin || isTeamAdmin;

  const handleControlSetsClick = () => {
    navigate(`/${ROUTES.SETTINGS}/${SETTINGS_ROUTES.THIRD_PARTY_CONTROL_SETS}`, {
      state: { returnTab: 'third-party' }
    });
  };

  const handleQuestionnairesClick = () => {
    navigate(`/${ROUTES.SETTINGS}/${SETTINGS_ROUTES.THIRD_PARTY_QUESTIONNAIRES}`, {
      state: { returnTab: 'third-party' }
    });
  };

  const handleIntakeFormClick = () => {
    navigate(`/${ROUTES.SETTINGS}/${SETTINGS_ROUTES.INTAKE_FORM}`, {
      state: { returnTab: 'third-party' }
    });
  };

  const handleTierMappingClick = () => {
    navigate(`/${ROUTES.SETTINGS}/${SETTINGS_ROUTES.TIER_MAPPING}`, {
      state: { returnTab: 'third-party' }
    });
  };

  const handleContinuousMonitoringClick = () => {
    navigate(`/${ROUTES.SETTINGS}/${SETTINGS_ROUTES.CONTINUOUS_MONITORING}`);
  };

  return (
    <div className="p-6 w-full h-full flex flex-col">
      <div className="mb-6">
        <h4 className="text-sm font-medium leading-5 text-[#171717]">
          Third-Party Risk Agent Settings
        </h4>
      </div>

      <div className="flex flex-wrap gap-4 items-start">
        {/* Intake Form Card - Only visible to Admins */}
        {isAdmin && (
        <Card
          className="cursor-pointer hover:shadow-md transition-shadow rounded-lg border border-[#E4E4E7] overflow-hidden"
          style={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
            minWidth: '300px',
            maxWidth: '376.33px',
            height: '180px',
            boxSizing: 'border-box',
            flex: '1 1 calc(33.333% - 1rem)',
            order: 0
          }}
          isPressable
          onPress={handleIntakeFormClick}
        >
          <CardBody
            className="flex flex-col items-start overflow-hidden"
            style={{
              padding: '16px',
              gap: '16px',
              height: '100%'
            }}
          >
            {/* Icon container */}
            <div
              className="flex flex-row items-center"
              style={{
                padding: '4px 0px',
                gap: '4px',
                width: '40px',
                height: '48px',
                flex: 'none',
                order: 0,
                flexGrow: 0
              }}
            >
              <img
                src={ClipboardPenIcon}
                alt="Intake Form"
                style={{
                  width: '40px',
                  height: '40px',
                  flex: 'none',
                  order: 0,
                  flexGrow: 0
                }}
              />
            </div>

            {/* Content container */}
            <div
              className="flex flex-col items-start self-stretch overflow-hidden"
              style={{
                padding: '0px',
                gap: '4px',
                width: '344.33px',
                // height: '64px',
                flex: 'none',
                order: 1,
                flexGrow: 0
              }}
            >
              {/* Title container */}
              <div
                className="flex flex-row items-start self-stretch"
                style={{
                  padding: '0px',
                  gap: '4px',
                  width: '344.33px',
                  height: '20px',
                  flex: 'none',
                  order: 0
                }}
              >
                <h5
                  className="font-medium"
                  style={{
                    width: '344.33px',
                    height: '20px',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#3F3F46',
                    flex: 'none',
                    order: 0,
                    flexGrow: 1
                  }}
                >
                  Intake Form
                </h5>
              </div>

              {/* Description */}
              <p
                className="self-stretch"
                style={{
                  width: '344.33px',
                  height: '54px',
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '20px',
                  color: '#71717A',
                  flex: 'none',
                  order: 1,
                  flexGrow: 0
                }}
              >
                  Capture business context about how the vendor is going to be used and integrated.
                </p>
            </div>
          </CardBody>
        </Card>
        )}

        {/* Tier Mapping Card - Hidden */}
        {false && isAdmin && (
        <Card
          className="cursor-pointer hover:shadow-md transition-shadow rounded-lg border border-[#E4E4E7] overflow-hidden"
          style={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
            minWidth: '300px',
            maxWidth: '376.33px',
            height: '180px',
            boxSizing: 'border-box',
            flex: '1 1 calc(33.333% - 1rem)',
            order: 1
          }}
          isPressable
          onPress={handleTierMappingClick}
        >
          <CardBody
            className="flex flex-col items-start overflow-hidden"
            style={{
              padding: '16px',
              gap: '16px',
              height: '100%'
            }}
          >
            {/* Icon container */}
            <div
              className="flex flex-row items-center"
              style={{
                padding: '4px 0px',
                gap: '4px',
                width: '40px',
                height: '48px',
                flex: 'none',
                order: 0,
                flexGrow: 0
              }}
            >
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  background: 'linear-gradient(135deg, #FF6496 0%, #812DD6 100%)',
                  WebkitMask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="6" rx="1"/><rect x="3" y="12" width="14" height="6" rx="1"/><rect x="3" y="21" width="10" height="0" rx="1"/><path d="M3 14h14M3 5h18"/></svg>')}")`,
                  mask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="6" rx="1"/><rect x="3" y="12" width="14" height="6" rx="1"/><rect x="3" y="21" width="10" height="0" rx="1"/><path d="M3 14h14M3 5h18"/></svg>')}")`,
                  WebkitMaskSize: '100% 100%',
                  maskSize: '100% 100%',
                  WebkitMaskRepeat: 'no-repeat',
                  maskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  maskPosition: 'center',
                  flex: 'none',
                  order: 0,
                  flexGrow: 0
                }}
              />
            </div>

            {/* Content container */}
            <div
              className="flex flex-col items-start self-stretch overflow-hidden"
              style={{
                padding: '0px',
                gap: '4px',
                width: '344.33px',
                flex: 'none',
                order: 1,
                flexGrow: 0
              }}
            >
              {/* Title container */}
              <div
                className="flex flex-row items-start self-stretch"
                style={{
                  padding: '0px',
                  gap: '4px',
                  width: '344.33px',
                  height: '20px',
                  flex: 'none',
                  order: 0
                }}
              >
                <h5
                  className="font-medium"
                  style={{
                    width: '344.33px',
                    height: '20px',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#3F3F46',
                    flex: 'none',
                    order: 0,
                    flexGrow: 1
                  }}
                >
                  Tier Mapping
                </h5>
              </div>

              {/* Description */}
              <p
                className="self-stretch"
                style={{
                  width: '344.33px',
                  height: '54px',
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '20px',
                  color: '#71717A',
                  flex: 'none',
                  order: 1,
                  flexGrow: 0
                }}
              >
                Define tier levels and map control sets and questionnaires to each tier for structured vendor assessments.
              </p>
            </div>
          </CardBody>
        </Card>
        )}

        {/* Control Sets Card */}
        <Card
          className="cursor-pointer hover:shadow-md transition-shadow rounded-lg border border-[#E4E4E7] overflow-hidden"
          style={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
            minWidth: '300px',
            maxWidth: '376.33px',
            height: '180px',
            boxSizing: 'border-box',
            flex: '1 1 calc(33.333% - 1rem)',
            order: 2
          }}
          isPressable
          onPress={handleControlSetsClick}
        >
          <CardBody
            className="flex flex-col items-start overflow-hidden"
            style={{
              padding: '16px',
              gap: '16px',
              height: '100%'
            }}
          >
            {/* Icon container */}
            <div
              className="flex flex-row items-center"
              style={{
                padding: '4px 0px',
                gap: '4px',
                width: '40px',
                height: '48px',
                flex: 'none',
                order: 0,
                flexGrow: 0
              }}
            >
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  background: 'linear-gradient(135deg, #FF6496 0%, #812DD6 100%)',
                  WebkitMask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/><polyline points="10,2 10,10 13,7 16,10 16,2"/></svg>')}")`,
                  mask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/><polyline points="10,2 10,10 13,7 16,10 16,2"/></svg>')}")`,
                  WebkitMaskSize: '100% 100%',
                  maskSize: '100% 100%',
                  WebkitMaskRepeat: 'no-repeat',
                  maskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  maskPosition: 'center',
                  flex: 'none',
                  order: 0,
                  flexGrow: 0
                }}
              />
            </div>

            {/* Content container */}
            <div
              className="flex flex-col items-start self-stretch overflow-hidden"
              style={{
                padding: '0px',
                gap: '4px',
                width: '344.33px',
                // height: '64px',
                flex: 'none',
                order: 1,
                flexGrow: 0
              }}
            >
              {/* Title container */}
              <div
                className="flex flex-row items-start self-stretch"
                style={{
                  padding: '0px',
                  gap: '4px',
                  width: '344.33px',
                  height: '20px',
                  flex: 'none',
                  order: 0
                }}
              >
                <h5
                  className="font-medium"
                  style={{
                    width: '344.33px',
                    height: '20px',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#3F3F46',
                    flex: 'none',
                    order: 0,
                    flexGrow: 1
                  }}
                >
                  Control Sets
                </h5>
              </div>

              {/* Description */}
              <p
                className="self-stretch"
                style={{
                  width: '344.33px',
                  height: '54px',
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '20px',
                  color: '#71717A',
                  flex: 'none',
                  order: 1,
                  flexGrow: 0
                }}
              >
                  Maintain sets of assessment controls to match the scope and purpose of your evaluation.
                </p>
            </div>
          </CardBody>
        </Card>

        {/* Questionnaires Card */}
        {isAdmin && (
        <Card
          className="cursor-pointer hover:shadow-md transition-shadow rounded-lg border border-[#E4E4E7] overflow-hidden"
          style={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
            minWidth: '300px',
            maxWidth: '376.33px',
            height: '180px',
            boxSizing: 'border-box',
            flex: '1 1 calc(33.333% - 1rem)',
            order: 3
          }}
          isPressable
          onPress={handleQuestionnairesClick}
        >
          <CardBody
            className="flex flex-col items-start overflow-hidden"
            style={{
              padding: '16px',
              gap: '16px',
              height: '100%'
            }}
          >
            {/* Icon container */}
            <div
              className="flex flex-row items-center"
              style={{
                padding: '4px 0px',
                gap: '4px',
                width: '40px',
                height: '48px',
                flex: 'none',
                order: 0,
                flexGrow: 0
              }}
            >
              <div
                style={{
                  width: '40px',
                  minHeight: '40px',
                  background: 'linear-gradient(135deg, #FF6496 0%, #812DD6 100%)',
                  WebkitMask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10,9 9,9 8,9"/></svg>')}")`,
                  mask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10,9 9,9 8,9"/></svg>')}")`,
                  WebkitMaskSize: '100% 100%',
                  maskSize: '100% 100%',
                  WebkitMaskRepeat: 'no-repeat',
                  maskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  maskPosition: 'center',
                  flex: 'none',
                  order: 0,
                  flexGrow: 0
                }}
              />
            </div>

            {/* Content container */}
            <div
              className="flex flex-col items-start self-stretch overflow-hidden"
              style={{
                padding: '0px',
                gap: '4px',
                width: '344.33px',
                // height: '64px',
                flex: 'none',
                order: 1,
                flexGrow: 0
              }}
            >
              {/* Title container */}
              <div
                className="flex flex-row items-start self-stretch"
                style={{
                  padding: '0px',
                  gap: '4px',
                  width: '344.33px',
                  height: '20px',
                  flex: 'none',
                  order: 0
                }}
              >
                <h5
                  className="font-medium"
                  style={{
                    width: '344.33px',
                    height: '20px',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#3F3F46',
                    flex: 'none',
                    order: 0,
                    flexGrow: 1
                  }}
                >
                  Questionnaire & Document Sets
                </h5>
              </div>

              {/* Description */}
              <p
                className="self-stretch"
                style={{
                  width: '344.33px',
                  height: '54px',
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '20px',
                  color: '#71717A',
                  flex: 'none',
                  order: 1,
                  flexGrow: 0
                }}
              >
                Create and maintain questionnaires for vendor input and define any documentation that will be required from the vendor.
                </p>
            </div>
          </CardBody>
        </Card>
        )}

        {/* Continuous Monitoring Card - Only visible to Admins */}
        {isAdmin && (
        <Card
          className="cursor-pointer hover:shadow-md transition-shadow rounded-lg border border-[#E4E4E7] overflow-hidden"
          style={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
            minWidth: '300px',
            maxWidth: '376.33px',
            height: '180px',
            boxSizing: 'border-box',
            flex: '1 1 calc(33.333% - 1rem)',
            order: 4
          }}
          isPressable
          onPress={handleContinuousMonitoringClick}
        >
          <CardBody
            className="flex flex-col items-start overflow-hidden"
            style={{
              padding: '16px',
              gap: '16px',
              height: '100%'
            }}
          >
            {/* Icon container */}
            <div
              className="flex flex-row items-center"
              style={{
                padding: '4px 0px',
                gap: '4px',
                width: '40px',
                height: '48px',
                flex: 'none',
                order: 0,
                flexGrow: 0
              }}
            >
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  background: 'linear-gradient(135deg, #FF6496 0%, #812DD6 100%)',
                  WebkitMask: `url("data:image/svg+xml,${encodeURIComponent('<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.33334 26.6666V21.6666C8.33334 21.2246 8.50894 20.8006 8.8215 20.4881C9.13406 20.1755 9.55798 19.9999 10 19.9999H30C30.442 19.9999 30.866 20.1755 31.1785 20.4881C31.4911 20.8006 31.6667 21.2246 31.6667 21.6666V26.6666M20 19.9999V13.3333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M35 26.6665H28.3334C27.4129 26.6665 26.6667 27.4127 26.6667 28.3332V34.9998C26.6667 35.9203 27.4129 36.6665 28.3334 36.6665H35C35.9205 36.6665 36.6667 35.9203 36.6667 34.9998V28.3332C36.6667 27.4127 35.9205 26.6665 35 26.6665Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.6667 26.6665H5.00001C4.07954 26.6665 3.33334 27.4127 3.33334 28.3332V34.9998C3.33334 35.9203 4.07954 36.6665 5.00001 36.6665H11.6667C12.5872 36.6665 13.3333 35.9203 13.3333 34.9998V28.3332C13.3333 27.4127 12.5872 26.6665 11.6667 26.6665Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M23.3333 3.33325H16.6667C15.7462 3.33325 15 4.07944 15 4.99992V11.6666C15 12.5871 15.7462 13.3333 16.6667 13.3333H23.3333C24.2538 13.3333 25 12.5871 25 11.6666V4.99992C25 4.07944 24.2538 3.33325 23.3333 3.33325Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>')}")`,
                  mask: `url("data:image/svg+xml,${encodeURIComponent('<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.33334 26.6666V21.6666C8.33334 21.2246 8.50894 20.8006 8.8215 20.4881C9.13406 20.1755 9.55798 19.9999 10 19.9999H30C30.442 19.9999 30.866 20.1755 31.1785 20.4881C31.4911 20.8006 31.6667 21.2246 31.6667 21.6666V26.6666M20 19.9999V13.3333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M35 26.6665H28.3334C27.4129 26.6665 26.6667 27.4127 26.6667 28.3332V34.9998C26.6667 35.9203 27.4129 36.6665 28.3334 36.6665H35C35.9205 36.6665 36.6667 35.9203 36.6667 34.9998V28.3332C36.6667 27.4127 35.9205 26.6665 35 26.6665Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.6667 26.6665H5.00001C4.07954 26.6665 3.33334 27.4127 3.33334 28.3332V34.9998C3.33334 35.9203 4.07954 36.6665 5.00001 36.6665H11.6667C12.5872 36.6665 13.3333 35.9203 13.3333 34.9998V28.3332C13.3333 27.4127 12.5872 26.6665 11.6667 26.6665Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M23.3333 3.33325H16.6667C15.7462 3.33325 15 4.07944 15 4.99992V11.6666C15 12.5871 15.7462 13.3333 16.6667 13.3333H23.3333C24.2538 13.3333 25 12.5871 25 11.6666V4.99992C25 4.07944 24.2538 3.33325 23.3333 3.33325Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>')}")`,
                  WebkitMaskSize: '100% 100%',
                  maskSize: '100% 100%',
                  WebkitMaskRepeat: 'no-repeat',
                  maskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  maskPosition: 'center',
                  flex: 'none',
                  order: 0,
                  flexGrow: 0
                }}
              />
            </div>

            {/* Content container */}
            <div
              className="flex flex-col items-start self-stretch overflow-hidden"
              style={{
                padding: '0px',
                gap: '4px',
                width: '344.33px',
                // height: '64px',
                flex: 'none',
                order: 1,
                flexGrow: 0
              }}
            >
              {/* Title container */}
              <div
                className="flex flex-row items-start self-stretch"
                style={{
                  padding: '0px',
                  gap: '4px',
                  width: '344.33px',
                  height: '20px',
                  flex: 'none',
                  order: 0
                }}
              >
                <h5
                  className="font-medium"
                  style={{
                    width: '344.33px',
                    height: '20px',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#3F3F46',
                    flex: 'none',
                    order: 0,
                    flexGrow: 1
                  }}
                >
                  Continuous Monitoring
                </h5>
              </div>

              {/* Description */}
              <p
                className="self-stretch"
                style={{
                  width: '344.33px',
                  height: '54px',
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '20px',
                  color: '#71717A',
                  flex: 'none',
                  order: 1,
                  flexGrow: 0
                }}
              >
                Define automated processes that take action based on real-time vendor events and risk triggers.
              </p>
            </div>
          </CardBody>
        </Card>
        )}
      </div>
    </div>
  );
};

export default ThirdPartyRiskLanding;
